import './MyGoals.scss'

import UserCheckinContext from 'components/common/contexts/UserCheckinContext'
import { ROUTE_TODAY } from 'components/common/helpers/Paths'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Alert, Card, Col, Row } from 'react-bootstrap'
import Loading from 'templates/Loading'
import CheckinChart from './CheckinChart'

export default function Summary({ setReturnPath, setHeaderTitle }) {
  const { summaryUserCheckin } = useContext(UserCheckinContext)

  const [loading, setLoading] = useState(true)
  const [measures, setMeasures] = useState([])

  useEffect(() => {
    setReturnPath(ROUTE_TODAY)
    setHeaderTitle('Summary')
  }, [setReturnPath, setHeaderTitle])

  useEffect(() => {
    if (!summaryUserCheckin) return
    if (summaryUserCheckin.length === 0) return
    if (summaryUserCheckin.error) return

    setLoading(false)
  }, [summaryUserCheckin])

  const chartData = useMemo(() => {
    if (loading) return []
    if (summaryUserCheckin.length === 0) return []

    // We may return an empty array if the user has no checkins, so we need to check for that
    const dates = [...new Set(summaryUserCheckin.map(s => s && s.checkin_date))]

    return dates.map(d => {
      const data = {}
      const checkins = summaryUserCheckin.filter(s => s.checkin_date === d)
      data.name = new Date(d.replace(/-/g, '/'))
        .toLocaleDateString('en', {
          day: 'numeric',
          month: 'numeric'
        })
        .replace('/', '-')

      checkins.forEach(c => {
        data[c.measure_name] = c.value
      })
      return data
    })
  }, [loading, summaryUserCheckin])

  useEffect(() => {
    if (loading) return

    const date = summaryUserCheckin[0]?.checkin_date
    const firstCheckin = summaryUserCheckin.filter(s => s.checkin_date === date)

    // We may return an empty array if the user has no checkins, so we need to check for that
    if (firstCheckin.length) setMeasures(firstCheckin.map(f => f.measure_name))
  }, [loading, summaryUserCheckin])

  const getCheckByMeasure = useCallback(
    measure => {
      const checkins = summaryUserCheckin.filter(
        s => s.measure_name === measure
      )
      return checkins.map(c => ({
        name: new Date(c.checkin_date.replace(/-/g, '/'))
          .toLocaleDateString('en', {
            day: 'numeric',
            month: 'numeric'
          })
          .replace('/', '-'),
        value: c.value
      }))
    },
    [summaryUserCheckin]
  )

  return (
    <Loading isLoaded={loading}>
      <div className='summary mt-3'>
        <Row>
          <Col>
            <p>
              Track your progress to identify patterns and improve your mental
              health.
            </p>
          </Col>
        </Row>

        {chartData.length > 1 ? (
          <Row>
            <Col style={{ height: '300px' }}>
              {measures.map((m, index) => (
                <Card variant='light' className='mb-3' key={index}>
                  <Card.Body className='p-1'>
                    <Row className='mb-4 px-3'>
                      <Col xs={12} className='mb-3'>
                        <h3>{m}</h3>
                      </Col>
                      <Col xs={12} style={{ height: '200px' }}>
                        <CheckinChart
                          chartData={getCheckByMeasure(m)}
                          dataKey='value'
                          configIndex={index}
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              ))}
            </Col>
          </Row>
        ) : (
          <Alert variant='secondary'>
            Come back tomorrow to see your progress.
          </Alert>
        )}
      </div>
    </Loading>
  )
}
